const input = {
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        rules: {
            type: String,
            default: 'required'
        },
        name: {
            type: String,
            default: ''
        }
    }
}

export default input
